<template>
  <a-drawer
    title="新增项目"
    :maskClosable="false"
    width="750"
    placement="right"
    :closable="false"
    @close="onClose"
    :visible="projectAddVisiable"
    style="height: calc(100% - 55px); overflow: auto; padding-bottom: 53px"
  >
    <a-form :form="form">
      <a-form-item label="合同号" v-bind="formItemLayout">
        <a-input
          style="width: 100%"
          v-decorator="[
            'contractNo',
            {
              rules: [
                { required: true, message: '不能为空' },
                { max: 20, message: '长度不能超过20个字符' },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="项目名称" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                { required: true, message: '不能为空' },
                { max: 200, message: '长度不能超过200个字符' },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="产品线" v-bind="formItemLayout">
        <a-select
          @change="onProductLineChange"
          v-decorator="[
            'productLine',
            { rules: [{ required: true, message: '请选择产品线' }] },
          ]"
        >
          <a-select-option
            v-for="line in productLineData"
            :key="line"
            :value="line"
            >{{line }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="产品型号" v-bind="formItemLayout">
        <a-select
          v-decorator="[
            'productVersion',
            { rules: [{ required: true, message: '请选择产品型号' }] },
          ]"
        >
          <a-select-option
            v-for="version in productVersionArray"
            :key="version"
            :value="version"
            >{{version }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="数量" v-bind="formItemLayout">
        <a-input-number
          :min="1"
          v-decorator="[
            'amount',
            { rules: [{ required: true, message: '不能为空' }] },
          ]"
        />
      </a-form-item>
      <a-form-item label="发货日期" v-bind="formItemLayout">
        <a-date-picker
          v-decorator="[
            'actualDate',
            { rules: [{ required: true, message: '不能为空' }] },
          ]"
        />
      </a-form-item>
      <a-form-item label="SAP订单号" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'sapNo',
            { rules: [
              { required: true, message: '不能为空' },
              { max: 50, message: '长度不能超过50个字符' }
              ] 
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="工厂" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'factory',
            {
              rules: [
                { required: true, message: '不能为空' },
                { max: 255, message: '长度不能超过255个字符' },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="项目地址" required v-bind="formItemLayout">
        <v-distpicker
          @selected="onSelected"
          :province="project.province"
          :city="project.city"
          :hideArea="true"
        ></v-distpicker>
      </a-form-item>
    </a-form>
    <div class="drawer-bootom-button">
      <a-button
        style="margin-right: 0.8rem"
        @click="addEmptyProject"
        type="dashed"
        :loading="loading"
        >创建空项目</a-button
      >
      <!-- <a-popconfirm
        title="确定放弃编辑？"
        @confirm="onClose"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm> -->
			<a-button @click="onClose" style="margin-right: 0.8rem">取消</a-button>
      <a-button @click="handleSubmit" type="primary" :loading="loading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 },
};
const productLineData = ['VCB', 'Assy', 'RMU', 'Others'];
const productVersionData = {
  VCB: ['VS1', 'E-VAC', '3AS4', '3AS2', 'VCP', 'VE24', 'SL', '405W-VAC', 'W-VACi'],
  Assy: ['ET1', 'UX', 'MV starter', 'DX', 'Xboard', 'VFD'],
  RMU: ['Xiria', 'Xiria-Plus'],
  Others: ['Others'],
};

export default {
  name: "projectAdd",
  props: {
    projectAddVisiable: {
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      formItemLayout,
      productLineData,
      productVersionData,
      productVersionArray: [],
      form: this.$form.createForm(this),
      project: {
        province: "",
        city: "",
      },
    };
  },
  methods: {
    reset() {
      this.loading = false;
      this.project = {};
      this.form.resetFields();
    },
    onClose() {
      this.reset();
      this.$emit("close");
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.setProjectFields();
          if (this.project.province == "" || this.project.city == "" ) {
            this.$notification.warning({
              message: "警告提示",
              description: "省市为必填",
            });
            return;
          }
          this.$post("project", {
            ...this.project,
          })
            .then(() => {
              this.reset();
              this.$emit("success");
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    addEmptyProject() {
      this.$post("project", {})
        .then(() => {
          this.reset();
          this.$emit("success");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onProductLineChange(value) {
      this.productVersionArray = productVersionData[value]
    },
    setProjectFields() {
      let values = this.form.getFieldsValue([
        "contractNo",
        "name",
        "productVersion",
        "productLine",
        "amount",
        "actualDate",
        "sapNo",
        "factory"
      ]);
      if (typeof values !== "undefined") {
        Object.keys(values).forEach((_key) => {
          this.project[_key] = values[_key];
        });
      }
    },
    onSelected(data) {
      this.project.province = data.province.value;
      this.project.city = data.city.value;
    },
  },
};
</script>
